import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as fasFaStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as farFaStar } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Typography } from '@scale/scaleui';

import { AuditResultV2 } from '@scale/shared/defaults';
import _ from 'lodash';

const valueIndexMapping = {
  [AuditResultV2.Terrible]: 0,
  [AuditResultV2.Bad]: 1,
  [AuditResultV2.Ok]: 2,
  [AuditResultV2.Good]: 3,
  [AuditResultV2.Perfect]: 4,
  [AuditResultV2.Undecided]: null,
};

const indexValueMapping: { [key: number]: AuditResultV2 } = {
  0: AuditResultV2.Terrible,
  1: AuditResultV2.Bad,
  2: AuditResultV2.Ok,
  3: AuditResultV2.Good,
  4: AuditResultV2.Perfect,
};

const starIndexDescriptionMapping: { [key: number]: string } = {
  0: 'Terrible',
  1: 'Bad',
  2: 'Ok',
  3: 'Good',
  4: 'Perfect',
};

export const ChatBulkAuditResultToggle: React.FC<{
  value: AuditResultV2 | null;
  onChange: (value: AuditResultV2 | null) => void;
  disabled?: boolean;
}> = props => {
  const { value, onChange } = props;
  const starCount = 5; // Number of stars

  const [starIndex, setStarIndex] = useState<number | null>(null);

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      {Array.from({ length: starCount }, (_element, index) => (
        <button
          key={index}
          onClick={() => onChange(indexValueMapping[index])}
          style={{ marginRight: '5px' }}
          disabled={props.disabled}
        >
          <FontAwesomeIcon
            icon={
              (!_.isNil(starIndex)
                ? index <= starIndex
                  ? fasFaStar
                  : farFaStar
                : !_.isNil(value) &&
                  !_.isNil(valueIndexMapping[value]) &&
                  index <= (valueIndexMapping[value] ?? -1)
                ? fasFaStar
                : farFaStar) as IconProp
              // override type based on here's issue: https://github.com/FortAwesome/react-fontawesome/issues/366
            }
            style={{
              background: '#F3F4F6',
              color: value && index <= (valueIndexMapping[value] ?? -1) ? '#E2A835' : '#8390A2',
              padding: '5px',
              width: '24px',
              height: '24px',
              borderRadius: '4px',
              borderColor: '#8390A2',
            }}
            onMouseEnter={() => {
              if (!props.disabled) setStarIndex(index);
            }}
            onMouseLeave={() => {
              if (!props.disabled) setStarIndex(null);
            }}
          />
        </button>
      ))}
      {!_.isNil(starIndex) && (
        <span style={{ alignSelf: 'center' }}>
          <Typography.Paragraph2>{starIndexDescriptionMapping[starIndex]}</Typography.Paragraph2>
        </span>
      )}
    </div>
  );
};
